import { Paper, Typography } from "@mui/material";
import { Box } from "@mui/system";
import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import styled from "styled-components";
import Logo from "./large.png";
import Back from "./back.svg";
import { Button, TextField } from "@mui/material";
import useProtectView from "../../Hooks/useProtectView";

const Img = styled.img`
  height: 150px;
  width: auto;
`;

export default function Login(props) {
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const canView = useProtectView();

  const navigate = useNavigate();
  const location = useLocation();

  const handleChangeUser = (e) => {
    setUserName(e.target.value);
  };

  const handleChangePass = (e) => {
    setPassword(e.target.value);
  };

  const setAuthInStorage = (token) => {
    window.localStorage.setItem("token", token);
  };

  async function signIn() {
    const response = await fetch(
      `${
        process.env.REACT_APP_API_SIGNIN_URL || "http://localhost:3011/signin"
      }`,
      {
        method: "post",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email: userName,
          password: password,
        }),
      }
    );

    const data = await response.json();

    return data;
  }

  async function handleLogin() {
    signIn().then((data) => {
      if (data.userId) {
        setAuthInStorage(data.token);

        if (canView("onlyPacking")) {
          navigate("/packing");

          window.location.reload();
        } else if (canView("onlySelf")) {
          navigate("/orders");

          window.location.reload();
        } else if
         (location.pathname === "/login") {
          navigate("/");

          window.location.reload();
        } else if (location.pathname === "/") {
          navigate("/orders");

          window.location.reload();
        } else {
          window.location.reload();
        }
      } else if (
        data === "To many failed log in attempts please conntact system admin"
      ) {
        window.alert(
          "To many failed log in attempts please conntact system admin"
        );
      } else {
        alert(
          "Your Username or Password does not match please enter a valid Username and Password"
        );
      }
    });
  }

  const login = (e) => {
    if (e.key === "Enter") {
      handleLogin();
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100vh",
        alignItems: "center",
        justifyContent: "center",
        backgroundImage: `url(${Back})`,
        backgroundSize: "cover",
        backgroundColor: "rgb(156, 39, 176, .1)",
      }}
    >
      <Paper
        sx={{
          height: "500px",
          width: "350px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "space-evenly",
          boxShadow: "0px 0px 4px 2px rgba(0, 0, 0, 0.2)",
        }}
      >
        <Img src={Logo} />
        <Box>
          <Typography>User Name</Typography>
          <TextField
            variant="outlined"
            type="text"
            onKeyUp={(e) => login(e)}
            onChange={(e) => handleChangeUser(e)}
          />
        </Box>

        <Box>
          <Typography>Password</Typography>
          <TextField
            variant="outlined"
            type="password"
            onKeyUp={(e) => login(e)}
            onChange={(e) => handleChangePass(e)}
          />
        </Box>

        <Button variant="contained" onClick={() => handleLogin()}>
          Log In
        </Button>
      </Paper>
    </Box>
  );
}
